// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nuverandaskriftwrap {
    display: flex;
    width: 100%;
    padding-bottom: 30px;
    flex-direction: column;
    align-items: center;
    background-color: var(--gray-more-lighter);
}

.heading {
    margin-top: 30px;
    margin-bottom: 30px;
    color: var(--gray-dark);
    font-size: 35px;
    font-weight: 700;
    text-align: center;
}

.div-block-57 {
    display: flex;
    max-width: 70%;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

.text-block-36 {
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: 6px;
    border-style: none none solid;
    border-width: 1px;
    border-color: var(--blue-darker);
    color: var(--gray-darkest);
    font-size: 20px;
    font-weight: 700;
    text-align: center;
}

._2cols {
    display: block;
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.col {
    display: flex;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 30px;
    flex-direction: column;
    align-items: center;
}

.heading-3 {
    margin-top: 0;
    margin-bottom: 0;
    color: var(--gray-dark);
    font-size: 25px;
    text-align: center;
}

.hr {
    width: 30%;
    height: 1px;
    margin-top: 15px;
    margin-bottom: 15px;
    background-color: var(--gray-lightest);
}

.texti {
    width: 400px;
    margin-top: 10px;
    padding-top: 0;
    padding-bottom: 0;
    color: var(--gray-darkest);
    font-size: 18px;
    line-height: 28px;
    font-weight: 300;
    text-align: center;
}

.note {
    margin-top: 5px;
    color: var(--gray-dark);
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;
}

.insertlink {
    color: var(--blue-darker);
    text-decoration: none;
}

.text-block-40 {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
}

.texti2 {
    margin-top: 10px;
    padding-top: 0;
    padding-bottom: 0;
    color: var(--gray-darkest);
    font-size: 22px;
    line-height: 28px;
    font-weight: 300;
    text-align: center;
}

.divLayout {
    display: inline-block;
    margin-left: 20px;
    margin-right: 20px;
}

.divLayout-2 {
    margin-top: 25px;
    margin-bottom: 25px;
}

.innskrabtn {
    display: block;
    width: 50%;
    margin-top: 20px;
    margin-right: auto;
    margin-left: auto;
    border-radius: 25px;
    background-color: #03aef3;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
}

.kaupabtn {
    width: 154px;
    margin-top: 20px;
    border-radius: 25px;
    background-color: var(--blue-darker);
    font-size: 16px;
    font-weight: 700;
    text-align: center;
}

.w-button {
    padding: 9px 15px;
    color: var(--white);
    border: 0;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
}

.css-3rj0br-ReactDropdownSelect {
    width: 150px !important;
    border-radius: 25px !important;
}

.texti3 {
    color: var(--gray-darkest);
    font-size: 18px;
    line-height: 28px;
    font-weight: 300;
    text-align: center;
}

.logowrapper {
    position: relative;
    display: flex;
    padding: 1rem 0px;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
}

.stadfestingtopwrap {
    display: flex;
    width: 100%;
    padding: 0px 20px;
    flex-direction: column;
    align-items: center;
}

.stadfestinglogo {
    margin-bottom: 20px;
}

img {
    max-width: 100%;
    vertical-align: middle;
    display: inline-block;
}

.stadfestingheader {
    color: #707070;
    font-size: 30px;
    font-weight: 500;
}

.stadfestingbottomwrap {
    padding: 1rem 20px;
    background-color: #fff;
}

.stadfestingtext {
    margin-bottom: 20px;
    color: #707070;
    font-size: 16px;
    line-height: 17px;
    font-weight: 300;
    text-align: center;
}

.styles_modal__gNwvD {
    max-width: 600px !important;
}

@media (max-width: 991px) {
    .nuverandaskriftwrap {
        width: 100%;
    }

    ._2cols {
        flex-direction: column;
    }

    .col {
        width: 100%;
    }
}

@media (max-width: 479px) {
    .heading {
        margin-bottom: 20px;
        font-size: 30px;
        line-height: 31px;
    }

    .div-block-57 {
        width: 100%;
        max-width: 90%;
    }

    .note {
        font-size: 14px;
    }

    .hr {
        width: 90%;
    }

    .texti {
        width: 90%;
        font-size: 15px;
    }

    .texti2 {
        font-size: 15px;
    }

    .texti3 {
        font-size: 15px;
    }

    .divLayout {
        margin-left: 10px;
        margin-right: 10px;
    }
}

@media (max-width: 360px) {
    .divLayout {
        display: block;
        margin-bottom: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/gildistimi/Layout/Layout.css"],"names":[],"mappings":"AAAA;IAII,aAAa;IACb,WAAW;IACX,oBAAoB;IAKpB,sBAAsB;IAItB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IAII,aAAa;IACb,cAAc;IAKd,sBAAsB;IAItB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IAKnB,sBAAsB;IAItB,8BAA8B;IAI9B,mBAAmB;AACvB;;AAEA;IAII,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IAKnB,sBAAsB;IAItB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAIlB,aAAa;IACb,iBAAiB;IAKjB,sBAAsB;IAItB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IAII,aAAa;IACb,WAAW;IACX,iBAAiB;IAKjB,sBAAsB;IAItB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QAKI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ","sourcesContent":[".nuverandaskriftwrap {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    padding-bottom: 30px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: var(--gray-more-lighter);\n}\n\n.heading {\n    margin-top: 30px;\n    margin-bottom: 30px;\n    color: var(--gray-dark);\n    font-size: 35px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.div-block-57 {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    max-width: 70%;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-top: 30px;\n}\n\n.text-block-36 {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-bottom: 6px;\n    border-style: none none solid;\n    border-width: 1px;\n    border-color: var(--blue-darker);\n    color: var(--gray-darkest);\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n}\n\n._2cols {\n    display: block;\n    margin-bottom: 20px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.col {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 30px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.heading-3 {\n    margin-top: 0;\n    margin-bottom: 0;\n    color: var(--gray-dark);\n    font-size: 25px;\n    text-align: center;\n}\n\n.hr {\n    width: 30%;\n    height: 1px;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    background-color: var(--gray-lightest);\n}\n\n.texti {\n    width: 400px;\n    margin-top: 10px;\n    padding-top: 0;\n    padding-bottom: 0;\n    color: var(--gray-darkest);\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 300;\n    text-align: center;\n}\n\n.note {\n    margin-top: 5px;\n    color: var(--gray-dark);\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 30px;\n    text-align: center;\n}\n\n.insertlink {\n    color: var(--blue-darker);\n    text-decoration: none;\n}\n\n.text-block-40 {\n    display: inline-block;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n}\n\n.texti2 {\n    margin-top: 10px;\n    padding-top: 0;\n    padding-bottom: 0;\n    color: var(--gray-darkest);\n    font-size: 22px;\n    line-height: 28px;\n    font-weight: 300;\n    text-align: center;\n}\n\n.divLayout {\n    display: inline-block;\n    margin-left: 20px;\n    margin-right: 20px;\n}\n\n.divLayout-2 {\n    margin-top: 25px;\n    margin-bottom: 25px;\n}\n\n.innskrabtn {\n    display: block;\n    width: 50%;\n    margin-top: 20px;\n    margin-right: auto;\n    margin-left: auto;\n    border-radius: 25px;\n    background-color: #03aef3;\n    font-size: 14px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.kaupabtn {\n    width: 154px;\n    margin-top: 20px;\n    border-radius: 25px;\n    background-color: var(--blue-darker);\n    font-size: 16px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.w-button {\n    padding: 9px 15px;\n    color: var(--white);\n    border: 0;\n    line-height: inherit;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.css-3rj0br-ReactDropdownSelect {\n    width: 150px !important;\n    border-radius: 25px !important;\n}\n\n.texti3 {\n    color: var(--gray-darkest);\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 300;\n    text-align: center;\n}\n\n.logowrapper {\n    position: relative;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 1rem 0px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: #fff;\n}\n\n.stadfestingtopwrap {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    padding: 0px 20px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.stadfestinglogo {\n    margin-bottom: 20px;\n}\n\nimg {\n    max-width: 100%;\n    vertical-align: middle;\n    display: inline-block;\n}\n\n.stadfestingheader {\n    color: #707070;\n    font-size: 30px;\n    font-weight: 500;\n}\n\n.stadfestingbottomwrap {\n    padding: 1rem 20px;\n    background-color: #fff;\n}\n\n.stadfestingtext {\n    margin-bottom: 20px;\n    color: #707070;\n    font-size: 16px;\n    line-height: 17px;\n    font-weight: 300;\n    text-align: center;\n}\n\n.styles_modal__gNwvD {\n    max-width: 600px !important;\n}\n\n@media (max-width: 991px) {\n    .nuverandaskriftwrap {\n        width: 100%;\n    }\n\n    ._2cols {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n        flex-direction: column;\n    }\n\n    .col {\n        width: 100%;\n    }\n}\n\n@media (max-width: 479px) {\n    .heading {\n        margin-bottom: 20px;\n        font-size: 30px;\n        line-height: 31px;\n    }\n\n    .div-block-57 {\n        width: 100%;\n        max-width: 90%;\n    }\n\n    .note {\n        font-size: 14px;\n    }\n\n    .hr {\n        width: 90%;\n    }\n\n    .texti {\n        width: 90%;\n        font-size: 15px;\n    }\n\n    .texti2 {\n        font-size: 15px;\n    }\n\n    .texti3 {\n        font-size: 15px;\n    }\n\n    .divLayout {\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n}\n\n@media (max-width: 360px) {\n    .divLayout {\n        display: block;\n        margin-bottom: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
